import { BlockComponentModel } from '@/cms/types/blok-component';
import Badge, { BadgeProps } from '.';

export interface BadgeStrapiProps {
  text: string;
  color?: 'info' | 'brand' | 'gradient' | 'black';
  variant?: BadgeProps['variant'];
  size?: BadgeProps['size'];
}

const mappedColor = {
  info: 'secondary-500',
  brand: 'brand-500',
  gradient: 'gradient',
  black: 'gray-900',
} as const;

export default function BadgeStrapi({
  block,
  inner,
}: BlockComponentModel<BadgeStrapiProps, BadgeProps>) {
  const { text, variant, color, size } = block;

  return (
    <Badge
      variant={variant}
      colors={color ? mappedColor[color] : 'gradient'}
      size={size}
      {...inner}
    >
      {text}
    </Badge>
  );
}
